import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async"; // Import HelmetProvider for SEO
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// ============================================================================
// APPLICATION ENTRY POINT
// ============================================================================
/**
 * This is the main entry point of the React application
 * * Flow:
 * 1. Find the HTML element with id="root" in public/index.html
 * 2. Create a React root using the new React 18 createRoot API
 * 3. Render the App component into that root, wrapped in HelmetProvider 
 * to allow per-page dynamic SEO metadata management.
 * * The App component then loads Routes, which manages all page navigation
 */

// Get the root DOM element where React will mount
// This element should exist in your public/index.html: <div id="root"></div>
const container = document.getElementById("root");

// Create a React root using React 18's Concurrent Mode
// This enables features like automatic batching and transitions
const root = createRoot(container);

// Render the main App component
// This starts the entire React component tree
root.render(
  // HelmetProvider is essential for managing the document head (title, meta tags)
  // in a CSR environment, which is crucial for SEO.
  <HelmetProvider>
    <App />
  </HelmetProvider>
);